import React from "react";
import styled from "styled-components";


const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const Card = styled.div`
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
`;

const Content = styled.div`
  padding: 1rem;
`;

const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
`;

const Rating = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5rem;

  span {
    margin-left: 0.5rem;
    color: #4a5568;
  }

  .star {
    color: #f6ad55;
  }
`;

const Tags = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

const Tag = styled.span`
  background-color: ${(props) => props.bgColor || "#edf2f7"};
  color: ${(props) => props.textColor || "#1a202c"};
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
`;

const Select = styled.select`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  margin-top: 1rem;
`;

const Button = styled.button`
  background-color: #ed8936;
  color: white;
  padding: 0.5rem;
  border: none;
  border-radius: 0.25rem;
  margin-top: 1rem;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: #dd6b20;
  }
`;



const ProductCards = ({addToCart,products}) => {
  return (
    <Container>
      <Grid>
        {products.map((product) => (
          <Card key={product.id}>
            <Image src={product.image} alt={product.name} />
            <Content>
              <Title>{product.name}</Title>
              <Rating>
                <i className="fas fa-star star"></i>
                <span>{product.rating}</span>
              </Rating>
              <Tags>
                {product.tags.map((tag, index) => (
                  <Tag
                    key={index}
                    bgColor={tag.includes("Veg") ? "#c6f6d5" : tag.includes("Non-veg") ? '#f69697' : "#fefcbf"}
                    textColor={tag.includes("Veg") ? "#2f855a" : tag.includes("Non-veg") ? '#c30010' : "#744210"}
                  >
                    {tag}
                  </Tag>
                ))}
              </Tags>
              <Select>
                {product.prices.map((price, index) => (
                  <option key={index}>{price}</option>
                ))}
              </Select>
              <Button onClick={() => { addToCart(product)}}>
                Add to cart
              </Button>
            </Content>
          </Card>
        ))}
      </Grid>
    </Container>
  );
};

export default ProductCards;
